module.exports = __webpack_public_path__ + "img/case_jtdx.52ce17f7.png";